

Vue.use(VueRouter);
const Register = () => import('./pages/register.vue')
const ProgressInfo = () => import('./pages/progressInfo.vue')
const PrivacyPolicy = () => import('./pages/privacyPolicy.vue')
const ApplicationNotice = () => import('./pages/applicationNotice.vue')
const InformationForm = () => import('./pages/informationForm.vue')


export default new VueRouter({
  // mode : 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'register',
      component: Register,
    },
		{
      path: '/progressInfo',
      name: 'progressInfo',
      component: ProgressInfo,
    },
		{
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: PrivacyPolicy,
    },
		{
			path: '/applicationNotice',
      name: 'applicationNotice',
      component: ApplicationNotice,
		},
		{
			path: '/informationForm',
      name: 'informationForm',
      component: InformationForm,
		},

    // ,{
    //   path: '*',
    //   name: '404',
    //   component: App404
    // }

  ]
})



// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/fgfRegister/router.js